import React from 'react';
import PropTypes from 'prop-types';
import TimelineStatus from '../../shopItems/ShopTimelineStatus';
import OrderProp from '../../propTypes/orderProp';
import translate from '../../../../commonComponents/translate';

function TimelineWrapper(props) {
  const { t, order, currency, isOpportunity } = props;
  const title = isOpportunity
    ? t('opportunity.timeline')
    : t('shop.order_timeline');
  return (
    <div className="m-portlet timeline-wrapper">
      <h5 className="timeline-header">{title}</h5>
      <TimelineStatus
        t={t}
        orderHistory={order.history}
        currency={currency}
        isOpportunity={isOpportunity}
      />
    </div>
  );
}

TimelineWrapper.propTypes = {
  t: PropTypes.func.isRequired,
  order: PropTypes.shape(OrderProp.propType).isRequired,
  currency: PropTypes.string.isRequired,
  isOpportunity: PropTypes.bool,
};

TimelineWrapper.defaultProps = {
  isOpportunity: false,
};

export default translate(TimelineWrapper);
